import React, { Component } from 'react'

export default class extends Component {
    state = {
        cart: [
            { id: 1, width: "50%" },
            { id: 2, width: "20%" },

        ]
    }
    render() {
        return (
            <div className="dashboard-widgets p-3">


                <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <div className='mt-2 br-10 ' style={{ width: '20%', height: '18px', backgroundColor: '#dedede' }}></div>
                    <div className='mt-2 br-10 ' style={{ width: '100%', height: '18px', backgroundColor: '#dedede' }}></div>
                    <div className='mt-2 br-10 ' style={{ width: '70%', height: '18px', backgroundColor: '#dedede' }}></div>

                    <div className='mt-2' style={{}}>
                        {this.state.cart.map((cart) => (
                            <div className='br-15 mt-4 position-relative' key={cart.id} style={{ marginRight: '10px' }}>
                                <div className='br-15 mt-1' style={{ width: '100%', height: 28, backgroundColor: '#f3f3f3' }}></div>
                                <div className=' br-15 skeleton-box position-absolute' style={{ width: (cart.width), height: '28px', backgroundColor: '#dedede', top: 0 }}></div>

                                <div className='flexc'>
                                    <div className=' br-15 ml-2 mt-2' style={{ width: 18, height: 18, backgroundColor: '#dedede', borderRadius: 50 }}></div>
                                    <div className=' br-15 ml-2 mt-2' style={{ width: 40, height: 18, backgroundColor: '#dedede', borderRadius: 50 }}></div>

                                </div>
                            </div>
                        ))}


                    </div>

                </div >
            </div >
        )
    }
}
